import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ACL from '../../acl/components/ACL';
import ACLService from '../../acl/services/aclService'

import {
  Theme,
  createStyles,
  WithStyles,
  withStyles,
  Grid,
  Typography,
  CardContent,
  Card,
  Avatar,
  Menu,
  MenuItem,
  Chip,
  IconButton,
  Divider,
  Link,
  Tooltip,
} from '@material-ui/core';
import {
  MoreVert as MoreIcon,
} from '@material-ui/icons';
import { MyPATIconButton, MyPATLink } from '../../common';

import goalService from '../services/goalManagementService';
import { getGoalList } from '../actions/goalManagementActions';
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import { GOAL_ACTION_TYPE_CONST } from '../container/GoalManagementContainer';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import { toggleLicenseExpiredDialog, setLoggedInUser } from "../../login/actions/userActions";
import { CourseStatus, GoalListItem } from '../types/GoalListItem';
import MyPATTruncateText from '../../common/MyPATTruncateText';

const styles = (theme: Theme) => createStyles({

  actionContainer: {
    // padding: "20px 0px 0px",
    '& a:hover': {
      fontWeight: 600
    }
  },
  linkPointerDisabled: {
    pointerEvents: 'none',
    opacity: 0.4
  },

  actionIcon: {

  },

  capitalizeText: {
    textTransform: "capitalize",
  },

  cardContainer: {
    cursor: "pointer",
    background: '#FFFFFF',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: 8,
    margin: '8px 0',
  },

  goalCardHeader: {
    background: '#1D7DEA',
    height: 112
  },

  orangeAvtar: {
    background: 'rgb(245 134 19 / 37%)',
    color: 'rgb(255 128 18 / 93%)',
    marginTop:9,
    marginRight:6,
    marginBottom:6,
    marginLeft:8,
    textTransform:"uppercase"
  },

  fwNormal: {
    fontWeight: theme.typography.fontWeightRegular,
  },

  fontSizeX1: {
    fontSize: '1rem',
    fontFamily: 'Nunito',
    fontWeight: 600
  },

  fontSizeSM: {
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 400,
    fontFamily: 'Nunito'
  },

  goalTargetSatus: {
    display: 'flex',
    alignItems: 'center',
    '&>:nth-child(2)': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '230px',
    }
  },

  goalNameClasses: {
    display: 'flex',
    alignItems: 'center',
    '& div': {
      whiteSpace: 'nowrap',
      // overflow: 'hidden',
    //  textOverflow: 'ellipsis'
    }
  },

  darkText: {
    color: '#333333'
  },
  goalName:{
  overflow:"hidden",
  textOverflow:'ellipsis',
  maxWidth:'230px'
  },
  className:{
    overflow:"hidden",
    textOverflow:'ellipsis',
    width:'150px',
    color: '#999',
    },
  greyText: {
    color: '#666666'
  },

  goalCardContent: {
    padding: 0,
    '&:last-child': {
      paddingBottom: theme.spacing.unit / 8,
    },

  },

  goalCardContentInfo: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    paddingLeft: 20,
    alignItems: 'center',
  },

  goalIconGrid: {
    paddingRight: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2,
    borderRight: `1px solid ${theme.palette.grey[400]}`,
    '& > div': {
      height: theme.spacing.unit * 10,
      width: theme.spacing.unit * 10,
      border: `2px solid ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
      textAlign: 'center',
      backgroundColor: theme.palette.common.white,
      '& span': {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      }
    },
  },

  height2X: {
    height: 103
  },

  lineHeightXM: {
    lineHeight: '30px'
  },

  lineHeightSM: {
    lineHeight: '22px'
  },

  minHeightLG: {
    minHeight: 95
  },

  mb2x: {
    marginBottom: theme.spacing.unit * 2,
  },

  mt1X: {
    marginTop: 13
  },

  moreMenu: {
    '& li': {
      height: 'auto',
      fontWeight: 'normal',
      fontSize: '0.875rem',
      lineHeight: '1rem',
      color: '#666666',
      width: 157,
      borderRadius: 5,
      padding: 0,
      '&:focus': {
        backgroundColor: 'inherit !important'
      },
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.08) !important'
      },
      '& > ul': {
        width: 157
      },
      '& > a': {
        display: 'inline-block',
        width: '100%',
        height: theme.spacing.unit * 2,
        ...theme.mixins.gutters(),
        color: theme.palette.text.secondary,
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: '10px !important',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'none',
        }
      },
      '& > svg': {
        marginRight: theme.spacing.unit,
        fontSize: '1rem',
      }
    }
  },

  moreMenuButton: {
    right:16,
    color: "rgb(153 153 153)",
    // margin: "8px 0px 0px",
    position: "absolute",
    background: "rgb(0 0 0 / 0%)",
    '&:hover': {
      background: 'transparent !important',
      color: '#000 !important',
    },
    '&:hover:after': {
      content: '""',
      position: 'absolute',
      left: '50%',
      marginLeft: -5,
      bottom: -8,
      width: 0,
      height: 0,
      borderLeft: '5px solid rgba(0, 0, 0, 0)',
      borderRight: '5px solid rgba(0, 0, 0, 0)',
      borderBottom: '8px solid rgb(0, 0, 0)'
  }
  },

  paletteColor: {
    border: `2px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
  },

  paddingM: {
    padding: '30px 14px'
  },

  paddingXM: {
    padding: '14px 10px 14px'
  },

  subMenuItem: {
    display: "flex",
    justifyContent: "space-between",
    textTransform: 'capitalize',
  },

  statusChip: {
    background: '#FFFFFF',
    borderRadius: 20,
    fontSize: '0.75rem',
    height: 20,
    verticalAlign: '2px'
  },

  publishedChip: {
    border: '1px solid #30BE76',
    color: '#30BE76',
    marginBottom:'3px'
  },
  pastChip: {
    border: '1px solid red',
    color: 'red'
  },
  draftChip: {
    border: '1px solid #F4B40D',
    color: '#F4B40D',
    marginBottom:'3px'
  },
  unpublishGoalChip: {
    border: '1px solid #FF830F',
    color: '#FF830F'
  },

  whiteText: {
    color: '#fff'
  },

  tooltipDetails: {
    position: 'absolute',
    marginTop: 12,
    zIndex: 999999
},
targetYear:{
  color: '#666',
  fontSize: 16,
},

});

interface GoalCardProps extends WithStyles<typeof styles> {
  data: GoalListItem,
  editClickHandler: (id: string) => void,
  handleOpenDialogWithData: (dialogData: any, goalId: any, actionType: string) => void,
  addGoalClickHandler: (e: any, id: string, name: string) => void,  //mun code
  years: any,
  history: any,
  getGoalList: () => void,
  archived: Boolean,
  handleActionType: (type : string) => void,
  userData: any,
  loggedInUserData: any,
  isPostExpiryDays: any,
  showLicenseExpiredDialog: any,
  toggleLicenseExpiredDialog: any,
  setLoggedInUser: any,
  duplicateColor:string,
  duplicateBackgroundColor:string,
}

interface GoalCardState {
  moreMenuAnchor: any,
  openMenu: string,
  viewVersionState: boolean,
  viewVersionAnchor: any,
  editVersionState: boolean,
  editVersionAnchor: any,
  showTooltip: boolean,
  versionYearsArr : [];
}

class GoalCard extends Component<GoalCardProps, GoalCardState> {
  constructor(props: GoalCardProps) {
    super(props);
    this.state = {
      openMenu: '',
      moreMenuAnchor: null,
      viewVersionState: false,
      viewVersionAnchor: null,
      editVersionState: false,
      editVersionAnchor: null,
      showTooltip: false,
      versionYearsArr: []
    };

    this.handleAddVersionMenuClick = this.handleAddVersionMenuClick.bind(this);
    this.handleEditOnMenu = this.handleEditOnMenu.bind(this);
    this.handleDeleteGoalVersionMenuClick = this.handleDeleteGoalVersionMenuClick.bind(this);   
  }

  componentDidMount(){
    this.props.setLoggedInUser();
  }

  componentWillReceiveProps() {
  }

  handleViewVersionMenu = (event: any) => {
    event.stopPropagation();
    if (!this.state.viewVersionAnchor) {
      this.setState({
        viewVersionAnchor: event.currentTarget
      });
    }

    this.setState({
      viewVersionState: !this.state.viewVersionState
    });
  }

  handleEditVersionMenu = (event: any) => {
    event.stopPropagation();
   
    if (!this.state.editVersionAnchor) {
      this.setState({
        editVersionAnchor: event.currentTarget
      });
    }

    this.setState({
      editVersionState: !this.state.editVersionState
    });
  }

  handleViewVersionMenuLeave = (e: any) => {
    e.stopPropagation();
    this.setState({ viewVersionAnchor: null, viewVersionState: false });
  }

  handleEditVersionMenuLeave = (e: any) => {
    e.stopPropagation();
    this.setState({ editVersionAnchor: null, editVersionState: false });
  }

  handleMoreMenuOpen = (e: any, target: string) => {
    e.stopPropagation();
    this.setState({ moreMenuAnchor: e.currentTarget, openMenu: target });
  };

  handleMoreMenuClose = (e: any) => {
    e.stopPropagation();
    this.setState({
      moreMenuAnchor: null, openMenu: '', viewVersionAnchor: '',
      viewVersionState: false, editVersionAnchor: '', editVersionState: false, 
    })
  };

  handleAddVersionMenuClick = (data: any, e: any, latestGoalId: string) => {
    e.stopPropagation();
    if(this.props.isPostExpiryDays){
      this.props.toggleLicenseExpiredDialog(true);
    } else {
    this.props.handleOpenDialogWithData({...data, courseVersions: data.courses },latestGoalId, GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION);
    // this.props.handleActionType(GOAL_ACTION_TYPE_CONST.ADD_NEW_VERSION);
    this.handleMoreMenuClose(e);
    }
  }

  handleEditGoal = (groupId: string, e: any) => {
    e.stopPropagation();
    this.props.history.push(`/goal-management/edit/${groupId}`);
  }

  viewVersionYearClick = (groupId: any, versionId: any, e: any) => {
    e.stopPropagation();
    this.props.history.push(`/goal-management/edit/${groupId}#${versionId}`);
  }

  editVersionYearClick = (e: any,data: any,goal: any) => {
    e.stopPropagation();
    if(this.props.isPostExpiryDays){
      this.props.toggleLicenseExpiredDialog(true);
    } else {
     // console.log(goal)
    this.props.handleOpenDialogWithData(data,goal.id, GOAL_ACTION_TYPE_CONST.EDIT_VERSION);
    // this.props.handleActionType(GOAL_ACTION_TYPE_CONST.EDIT_VERSION);
    this.handleMoreMenuClose(e);
    }
  }

  handleEditOnMenu = (e: any, id: string, someThing: string) => {
    //INFO:This will help to close edit and add version openupwhen user clicks on any button
    this.setState({ openMenu: '' });
    this.props.addGoalClickHandler(e, id, someThing);
  }

  handleEditGoalMenuClick = (data: any,e: any, latestGoalId: string) => {
    e.stopPropagation();
    if(this.props.isPostExpiryDays){
      this.props.toggleLicenseExpiredDialog(true);
    } else {
    this.props.handleOpenDialogWithData(data,latestGoalId, GOAL_ACTION_TYPE_CONST.EDIT_GOAL);
    // this.props.handleActionType(GOAL_ACTION_TYPE_CONST.EDIT_GOAL);
    this.handleMoreMenuClose(e);
  }
  }

  handleDeleteGoalVersionMenuClick = (data: any, e: any, latestGoalId: string) => {
    e.stopPropagation();
    this.props.handleOpenDialogWithData(data, latestGoalId, GOAL_ACTION_TYPE_CONST.DELETE_VERSION);
    // this.props.handleActionType(GOAL_ACTION_TYPE_CONST.DELETE_VERSION);
    this.handleMoreMenuClose(e);

  }

  handleDuplicateGoalMenuClick = (data: any, e: any, latestGoalId: string) => {
    e.stopPropagation();
    this.props.handleOpenDialogWithData(data, latestGoalId, GOAL_ACTION_TYPE_CONST.DUPLICATE_GOAL);
    // this.props.handleActionType(GOAL_ACTION_TYPE_CONST.DUPLICATE_GOAL);
    this.handleMoreMenuClose(e);
  }

  handleHover() {
		this.setState({
            showTooltip: !this.state.showTooltip
        })
  }

  getLatestGoalId = () => {
    const { data } = this.props;
    let latestTargetYear = parseInt(data.courses[0].targetYear);
    let latestGoalId = data.courses[0].id;
    data.courses.forEach(course => {
      const targetYear = parseInt(course.targetYear)
      if(targetYear > latestTargetYear) {
        latestTargetYear = targetYear;
        latestGoalId = course.id;
      }
    });
    return latestGoalId;
  }
  
  render() {
    const {
      classes,
      data,
      years,
      addGoalClickHandler,
      archived,
      duplicateColor,
      duplicateBackgroundColor
    } = this.props;
    const {
      openMenu,
      moreMenuAnchor,
      viewVersionAnchor,
      viewVersionState,
      editVersionAnchor,
      editVersionState,
      showTooltip
    } = this.state;
    let eligibleVersions = [];
    (data.courses || []).forEach((course:any) => (course.status || '').toUpperCase() !== 'DRAFT' && eligibleVersions.push(course.targetYear));
    const isVersionAddingEnabled = !!eligibleVersions.length;
    // const avatar = () => {
    //   const colorCode = data.image
    //   if (!_.isUndefined(colorCode)) {
    //     return (
    //       <Avatar style={{ color: data.color, border: `2px solid ${data.color}` }}>
    //         <span>{data.name.slice(0, 2)}</span>
    //       </Avatar>
    //     )
    //   }
    //   else {
    //     return (
    //       <Avatar>
    //         <span>{data.name.slice(0, 2)}</span>
    //       </Avatar>
    //     )
    //   }
    // }
   const groupId = _.get(data.courses, '[0].groupId', '');
    const latestGoalId = this.getLatestGoalId();
    const SortedClasses = _.sortBy(data.classesEligible,['value'])
    let targetYear:any = new Set();
    const coursesToShow = data.courses ? [...data.courses].sort((a,b) => parseInt(b.targetYear) - parseInt(a.targetYear)) : [];
    coursesToShow.forEach((val:any)=>{
      targetYear.add(val.targetYear)
    })
    targetYear = [...targetYear]

    return (

      <Card className={classes.cardContainer} 
      elevation={0}
      onClick={this.handleEditGoal.bind(this, `${groupId}#${latestGoalId}`)}
      >

        <CardContent className={classes.goalCardContent}>
         
          <Grid container 
          direction="row"
          className={[ 
            classes.goalCardContentInfo,
            classes.paddingXM].join(' ')}>
            <Grid item xs={7}>
            <Grid container alignItems="center"
               direction="row">
                 <Grid item>
                    <Avatar className={classes.orangeAvtar} style={{color:duplicateColor,background:duplicateBackgroundColor}} src={data.image || ""}>{!data.image?<span>{data.name.slice(0,2)}</span>:""}</Avatar>
                 </Grid>
                 &nbsp;&nbsp;
                <Grid item xs="auto">
                  <Grid className={classes.goalNameClasses}>
                    <Grid className={[classes.capitalizeText, 
                      classes.lineHeightXM, 
                      classes.fontSizeX1, 
                      classes.darkText,classes.goalName].join(' ')}>
                        <Tooltip title={data.name}>
                          <div>
                            {data.name} 
                          </div>
                        </Tooltip>
                    </Grid>
                    &nbsp;&nbsp;
                    <Grid className={[classes.fontSizeSM, 
                      classes.lineHeightSM, 
                      classes.className].join(' ')}>
                        <Tooltip title={data.classesEligible && data.classesEligible.length > 0 ? _.map(SortedClasses, 'name').join(', ') : ''}>
                          <div>
                            Class {data.classesEligible && data.classesEligible.length > 0 ? _.map(SortedClasses, 'name').join(', ') : ''}
                          </div>
                        </Tooltip>
                    </Grid>
                  </Grid>

                  <Grid className={classes.goalTargetSatus}>
                    <Grid className={classes.targetYear}>
                      Target Year:&nbsp;
                    </Grid>
                    
                    <Grid className={[classes.fontSizeSM, 
                      classes.lineHeightSM, 
                      ].join(' ')}>    
                      <MyPATTruncateText
                        data={targetYear}
                        truncateLength={5}
                        displayCount={4}
                    />                
                    {/* {data.courses ? targetYears: ''} */}
                    </Grid>
                    &nbsp;&nbsp;
                    <Grid>
                      <Chip color="primary" label={_.capitalize(data.status)} className={[classes.statusChip, (data.status === CourseStatus.LIVE ? classes.publishedChip : data.status === CourseStatus.EXPIRED ? classes.pastChip:classes.draftChip )].join(' ')} variant="outlined" />
                    </Grid>
                  </Grid>                  
                </Grid>
            </Grid>
            </Grid>
            <Grid item xs={5}>
              <Grid container
              className={classes.actionContainer}
               direction="row" alignItems="center">
                <Grid item xs={6} className={!isVersionAddingEnabled ? classes.linkPointerDisabled : ''}>
                  <Grid container>
                    <div>
                    <span onClick={(e: any) => this.handleAddVersionMenuClick(data, e, latestGoalId)}>
                    <img height="18px" src="/assets/svg/goalManagement/plus.svg" alt="edit" />
                    </span> &nbsp;
                      <Link
                        variant="body2"
                        underline="none"
                        onClick={(e: any) => this.handleAddVersionMenuClick(data, e, latestGoalId)}
                      >
                        Add New Version
                      </Link>
                      </div>
                    </Grid>
                </Grid>
                <Grid item xs={6}>
                <Grid container>
                <span className={classes.actionIcon} 
                onClick={(e: any) => this.handleEditGoalMenuClick(data, e, latestGoalId)}>
                <img src="/assets/svg/goalManagement/edit.svg" alt="edit" />
                </span> &nbsp;
                  <Link
                    variant="body2"
                    underline="none"
                    onClick={(e: any) => this.handleEditGoalMenuClick(data, e, latestGoalId)}
                  >
                     Edit Goal
                  </Link>
                  </Grid>
                </Grid>
              </Grid>              
            </Grid>
           
            {!archived && (
              <>
                <IconButton
                  aria-haspopup="true"
                  onClick={(e: any) => this.handleMoreMenuOpen(e, `menu-${data._id}`)}
                  className={classes.moreMenuButton}
                  onMouseOver={this.handleHover.bind(this)} 
                  onMouseOut={this.handleHover.bind(this)}
                >
                  <MoreIcon />
                  {
					          showTooltip && 
				          	<>
                    <Grid>
                      <CustomInfoIcon 
                      isInfoIcon={false} 
                      isCenterArrow={false}
                      isRightArrow={showTooltip} 
                      details="Click to update Goal"
                      toolTipDirection="right"/>
                    </Grid>
                    </>
                    }
                </IconButton>
              
                <Menu
                  id={`menu-${data._id}`}
                  open={_.isEqual(`menu-${data._id}`, openMenu) ? true : false}
                  anchorEl={moreMenuAnchor}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  onClose={(e: any) => this.handleMoreMenuClose(e)}
                  className={classes.moreMenu}
                >
                  <MenuItem className={classes.subMenuItem}
                    onClick={this.handleViewVersionMenu.bind(this)}>
                       <KeyboardArrowLeft />
                    <a href="javascript:void(0)">View Version</a>
                  </MenuItem>
                  <Menu
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left"
                    }}
                    open={viewVersionState}
                    anchorEl={viewVersionAnchor}
                    onClose={(e: any) => this.handleViewVersionMenuLeave(e)}
                  >
                    {coursesToShow.map((course) => 
                      <MenuItem key={`index-${course.targetYear}`} onClick={this.viewVersionYearClick.bind(this, course.groupId, course.id)} className={classes.subMenuItem}
                      >
                        <a>{course.targetYear} ({_.capitalize(course.status)})</a>
                      </MenuItem>
                    )}                  
                </Menu>
                <Divider />
                <MenuItem className={classes.subMenuItem}
                  onClick={this.handleEditVersionMenu.bind(this)}>
                      <KeyboardArrowLeft />
                  <a href="javascript:void(0)">Edit Version</a>
                  </MenuItem>
                <Menu
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "left"
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left"
                    }}
                    open={editVersionState}
                    anchorEl={editVersionAnchor}
                    onClose={(e: any) => this.handleEditVersionMenuLeave(e)}
                  >
                    {coursesToShow.map((course) =>
                     <MenuItem key={`index-${course.targetYear}`}  onClick={(event) =>this.editVersionYearClick(event,data,course)} className={classes.subMenuItem}
                      >
                        <a>{course.targetYear} ({_.capitalize(course.status)})</a>
                      </MenuItem>
                    )}                  
                </Menu>
                {/* <Divider /> */}
                {/* {ACLService.hasAccessTo(['COURSE'], ['EDIT']) ? (
                  <MenuItem>
                    <a onClick={(e: any) => this.handleEditOnMenu(e, data._id, '')}>
                      Rename
												</a>
                  </MenuItem>
                ) : null}
                <Divider /> */}

                {/* <MenuItem onClick={this.handleAddVersionMenuClick.bind(this, data)}>
                  <a href="javascript:void(0)">Add New Version</a>
                </MenuItem> */}
                {/* <Divider /> */}
                {/* {ACLService.hasAccessTo(['COURSE'], ['DELETE']) ? (
                  <MenuItem onClick={this.handleDeleteGoalVersionMenuClick.bind(this, data)}>
                    <a href="javascript:void(0)">Delete Version</a>
                  </MenuItem>
                ) : null}
                <Divider /> */}
                {/* <MenuItem onClick={this.handleEditGoalMenuClick.bind(this, data)}>
                  <a href="javascript:void(0)">Edit Goal</a>
                </MenuItem> */}
                {/* <Divider />
                <MenuItem onClick={this.handleDuplicateGoalMenuClick.bind(this, data)}>
                  <a href="javascript:void(0)">Duplicate Goal</a>
                </MenuItem>                */}
              </Menu>
              </>)}
          </Grid>
        </CardContent>
      </Card >

    )
  }
}
const mapStateToProps = (state: any) => ({
  userData: state.loginData.userData,
  loggedInUserData:  state.loginData.userData &&  state.loginData.userData.loggedInUserData,
  showLicenseExpiredDialog:  state.loginData.userData &&  state.loginData.userData.showLicenseExpiredDialog,
  isPostExpiryDays:  state.loginData.userData &&  state.loginData.userData.isPostExpiryDays
  });

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  getGoalList,
  toggleLicenseExpiredDialog,
  setLoggedInUser
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(GoalCard));